import i18n from 'scoreboard/components/i18n'
import * as urlToLinks from 'scoreboard/components/urls-to-links'

/**
 * Builds a  explanation to display if the decimal separator for the locale
 * won't work with the equation syntax (with link to support article).
 * (#36115 #36316)
 */
function decimalSeparatorMessage() {
	let href = 'https://support.spiderstrategies.com/hc/en-us/articles/360041117552-Calculated-KPIs#unified_separators'
	let link = urlToLinks.createAnchor(href,
		'scorecards.node.metric.equation.instructions.supportArticle')
	let message = i18n.get('scorecards.node.metric.equation.instructions', link)
	return message

}

export default decimalSeparatorMessage
decimalSeparatorMessage.__filename__ = 'components/decimal-separator-message.js'
